import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { LogoLockup } from "@/components/Logo";
import MotionBackdrop from "@/components/MotionBackdrop";
import { useAuth } from "@/lib/AuthContext";

export default function SignUp() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const refCode = sp.get("ref") || "";
  const [form, setForm] = useState({ full_name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const on = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup(form.email, form.password, form.full_name, refCode || null);
      nav("/app/onboarding", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign-up failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen bg-[var(--tm-off)] flex items-center justify-center p-5 overflow-hidden">
      <MotionBackdrop />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8"><Link to="/"><LogoLockup /></Link></div>
        <div className="tm-card p-7 bg-white">
          <h1 className="text-2xl font-bold">Create your account</h1>
          <p className="mt-1 text-sm text-[#3B424B]">Set up your dealership in the next step.</p>
          {refCode && <div className="mt-3 tm-badge bg-[#14624A]/10 text-[#14624A]" data-testid="signup-ref-tag">Referred by {refCode}</div>}
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><label className="tm-label">Full name</label><input required className="tm-input" value={form.full_name} onChange={on("full_name")} data-testid="signup-name" /></div>
            <div><label className="tm-label">Work email</label><input type="email" required className="tm-input" value={form.email} onChange={on("email")} data-testid="signup-email" /></div>
            <div><label className="tm-label">Password</label><input type="password" minLength={8} required className="tm-input" value={form.password} onChange={on("password")} data-testid="signup-password" /><div className="mt-1 text-[11px] text-[#3B424B]">Minimum 8 characters.</div></div>
            <button type="submit" disabled={busy} className="tm-btn-primary w-full" data-testid="signup-submit">{busy ? "Creating…" : "Create account"}</button>
          </form>
          <div className="mt-5 text-sm text-[#3B424B]">Already have an account? <Link to="/signin" className="tm-link" data-testid="signup-signin-link">Sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
